import { render, staticRenderFns } from "./SiteTypeForm.vue?vue&type=template&id=47cfd120&"
import script from "./SiteTypeForm.vue?vue&type=script&lang=js&"
export * from "./SiteTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports